enum DelegationAddViewMode {
  CARGO = "CARGO",
  RAILY = "RAILY",
}

export default DelegationAddViewMode;
